import * as R from 'ramda';

import { cleanObject, filterSearchQuery } from './filters-summary';
import { fromQuery, getQueryParams } from './query-string';

const defaultQuery = {
  keywords: '',
  location: '',
  radius: '',
};

const filterPropNames = ['filter', 'filters'];

const filtersToAllow = [
  'benefits',
  'company',
  'city',
  'country',
  'discipline',
  'industry',
  'level',
  'projob',
  'salary',
  'segments',
  'student',
  'type',
  'remote_option',
];

const isNormalizedFilter = (value, key) => key.startsWith('filter.');

const getNormalizedFilters = R.pickBy(isNormalizedFilter);

const sortFilterValues = (value) => {
  if (!Array.isArray(value)) {
    return value;
  }
  if (isNaN(value[0])) {
    return value.sort();
  }

  return value.sort((a, b) => parseInt(a) - parseInt(b));
};

const flattenFilters = R.unless(
  R.isEmpty,
  R.compose(
    R.mergeAll,
    R.map(([key, value]) => ({ [`filter.${key}`]: sortFilterValues(value) })),
    R.toPairs,
    R.pick(filtersToAllow)
  )
);

const getFilters = R.compose(R.last, R.values, R.pick(filterPropNames));

const normalizeFilters = R.compose(R.unless(R.isNil, flattenFilters), getFilters);

const cleanQuery = R.compose(R.ifElse(R.has('location'), R.identity, R.dissoc('radius')), filterSearchQuery);

const normalizeQuery = (query) => ({
  ...cleanQuery(query),
  ...normalizeFilters(query),
  ...getNormalizedFilters(query),
});

export const prepareQuery = R.compose(normalizeQuery, cleanObject);

const cleanUrlQuery = R.compose(
  R.ifElse(R.prop('location'), R.identity, R.dissoc('radius')),
  R.pick(['keywords', 'location', 'radius', 'filter', 'filters', 'sc_o'])
);

export const createQueryFromUrl = R.compose(R.mergeRight(defaultQuery), cleanUrlQuery, fromQuery, getQueryParams);
